module.exports = __webpack_public_path__ + "static/media/icon-user-white.ddffd249.svg";